import React from 'react';
import './App.css';
import { Footer } from './Components/Footer/Footer';
import { Navbar } from './Components/Navbar/Navbar';
import { Home } from './Components/Home/Home';
 import { Products} from './Components/Products/Products';
 import { About } from './Components/About/About';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

function App() {
  return (
    <Router>
      <Navbar/>
      <div className="App">
        <header className="App-header">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/Products" component={Products} />
            <Route exact path="/About" component={About} />
            
          </Switch>
        </header>
      </div>
      <Footer/>
    </Router>
  );
}

export default App;
